import React, { useState } from "react"
import { Link } from "gatsby"
import ContentModule from "../../modules/content_module";
import { menuLinks } from "../../common/utils/page_url_utils";

import "./CarousalCard.scss";

const CarousalCard = ({item, increment}) => {
    
    var page_link = item?.cta_link?.custom_link ? item.cta_link?.custom_link : item?.cta_link?.menu_item?.slug ? menuLinks(item.cta_link.menu_item) : "";

    return (
        <React.Fragment>
            <div className="carousal-wrapper">
                <div className="carousal_count"><span>{increment}</span> {page_link && <Link to={page_link} className="card_icon"><i className="icon-right"></i></Link>}</div>

                <div className="carousal-content">
                    <h3>{item.title}</h3>
                    <ContentModule Content={item?.content} />
                </div>
            </div>

        </React.Fragment>
    );
};
export default CarousalCard;
